import React from 'react';
import { IconCreditCard } from '@tabler/icons-react';

const PaymentMethodCard = ({ cardDetails, onChangeClick }) => {
  // Helper function to format expiry
  const formatExpiry = (expiryMonth, expiryYear) => {
    if (!expiryMonth || !expiryYear) return '';
    if (expiryMonth > 9) return `${expiryMonth}/${expiryYear}`;
    return `0${expiryMonth}/${expiryYear}`;
  };

  // Handle empty state - no payment method on file
  if (!cardDetails) {
    return (
      <div className="payment-method-card">
        <div className="payment-method-header">
          <div>
            <h3>Payment Method</h3>
            <p>No payment method on file</p>
          </div>
          <button className="btn btn-primary" onClick={onChangeClick}>
            Add Payment Method
          </button>
        </div>
      </div>
    );
  }

  const cardBrand = cardDetails?.brand || 'Card';
  const last4 = cardDetails?.last4 || '••••';
  const expiry = formatExpiry(cardDetails?.exp_month, cardDetails?.exp_year);
  const ownerName = cardDetails?.name || cardBrand;

  return (
    <div className="payment-method-card">
      <div className="payment-method-header">
        <div>
          <h3>Payment Method</h3>
          <p>Manage your billing information</p>
        </div>
        <button className="btn-outlined" onClick={onChangeClick}>
          Change
        </button>
      </div>

      <div className="payment-card-display">
        <div className="payment-card-icon">
          <IconCreditCard size={24} />
        </div>
        <div className="payment-card-info">
          <p>
            {cardBrand} •••• {last4}{' '}
            <span className="badge-default">Default</span>
          </p>
          <p className="card-expiry">Exp {expiry}</p>
          <p className="card-owner">{ownerName}</p>
        </div>
      </div>
    </div>
  );
};

export default PaymentMethodCard;
